import React from "react";
import useFavorites from "../../../utils/useFavorites";
import { imageLoader } from "../../../utils/imageLoader";

const ListeLotsEnregistres = ({
  lotsFavoris,
  onLotClick,
  filterInput,
  setFilterInput,
}) => {
  const { handleAddToFavorites, isLotInFavorites } = useFavorites();
  return (
    <div className="">
      <div className="table mt-4">
        {/* Header */}
        <div className="table-fav-lots-header pink text-center ">
          <div className="table-cell" title="Lot"><img src="./icons/lots.svg" width={40} height={40} alt="Lot" /></div>
          <div className="table-cell" title="Dispositif"><img src="./icons/project-types.svg" width={45} height={45} alt="Dispositif" /></div>
          <div className="table-cell" title="Typologies"><img src="./icons/typologie.svg" width={45} height={45} alt="Typologies" /></div>
          <div className="table-cell" title="Surface"><img src="./icons/surface-int.svg" width={45} height={45} alt="Surface" /></div>
          <div className="table-cell" title="Etage"><img src="./icons/etage.svg" width={45} height={45} alt="Etage" /></div>
          <div className="table-cell" title="Prix"><img src="./icons/prix.svg" width={45} height={45} alt="Prix" /></div>
          <div className="table-cell" title="Prix/m²"><img src="./icons/prix-m2.svg" width={45} height={45} alt="Prix/m²" /></div>
          <div className="table-cell" title="Loyer"><img src="./icons/rent.svg" width={45} height={45} alt="Loyer" /></div>
          <div className="table-cell" title="Favoris"><img src="./icons/favoris.svg" width={45} height={45} alt="Favoris" /></div>
        </div>

        {/* Rows */}
        {lotsFavoris?.length > 0 ? (
          lotsFavoris.map((lot) => (
            <div
              key={lot.documentId}
              className="tables-rows-fav-lots cursor-pointer hoverborder"
              onClick={() => onLotClick(lot?.documentId)}
            >
              {/* Lot */}
              <div className="table-cell p-0">
                <div className="d-flex align-items-center gap-2">
                  <div className="plan-image position-relative">
                    <span
                      className={
                        lot?.disponibility?.disponibilite === "Disponible"
                          ? "position-absolute top-0 start-0 bg-green py-1 px-2 radius5 fs11 "
                          : "position-absolute top-0 start-0 bg-yellow py-1 px-2 radius5 fs11 "
                      }
                    >
                      {lot?.disponibility?.disponibilite === "Disponible"
                        ? "Disponible"
                        : "Optionné"}
                    </span>
                    <img
                      src={imageLoader(lot?.images[1]?.image[0]?.url)}
                      alt=""
                      className="radius5"
                    />
                  </div>
                  <div>
                    <p
                      className="mb-0 fs16 darkGrey semibold"
                      title={lot.reference}
                    >
                      {lot.reference}
                    </p>
                    {/* <p className="text-muted mb-0 fs11 darkGrey regular">
                      {lot.availability === "available"
                        ? "Disponible"
                        : "Optionné"}
                    </p> */}
                  </div>
                </div>
              </div>

              {/* Programme */}
              {/*   <div className="table-cell p-0">
                <div className="d-flex align-items-center gap-2">
                  <div className="program-image">
                    <img
                      src={imageLoader(lot.images[1]?.image[0]?.url)}
                      alt=""
                    />
                  </div>
                  <div className="d-flex flex-column text-start">
                    <div>
                      <p
                        className="mb-0 fs16 darkGrey semibold text-wrap "
                        title={lot.programme_parent.name}
                      >
                        {lot.programme_parent.name}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {lot.programme_parent.address}
                      </p>
                    </div>
                    <div>
                      <p className="mb-0 fs11 darkGrey semibold">
                        {lot.programme_parent.municipality}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {lot.programme_parent.delivery_date
                          ? moment(lot.programme_parent.delivery_date).format(
                              "YYYY"
                            ) +
                            " T-" +
                            moment(lot.programme_parent.delivery_date).quarter()
                          : "NC"}
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Dispositif */}
              <div className="table-cell">
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex flex-column justify-content-between gap6">
                    {lot?.project_types?.map((badge, index) => (
                      <span
                        key={badge.documentId}
                        className="fs11 bg-green radius5 py-1 px-2 text-white"
                        title={badge.label}
                      >
                        {badge.label}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Type */}
              <div className="table-cell text-capitalize">{lot.typology}</div>

              {/* Surface */}
              <div className="table-cell">{lot.surface}</div>

              {/* Étage */}
              <div className="table-cell">
                {lot.floor === null
                  ? "NC"
                  : lot.floor === 0
                    ? "RDC"
                    : lot.floor === 1
                      ? "1er"
                      : lot.floor + "ème"}
              </div>

              {/* Prix */}
              <div className="table-cell">
                <div className="text-center">
                  <small className="text-muted fs11 regular darkGrey">
                    {"TVA " + lot.price_vat_rate + "%"}
                  </small>
                  <p className="mb-0 fs16 semibold darkGrey">
                    {Intl.NumberFormat("fr-FR").format(lot.price_total) + " €"}
                  </p>
                </div>
              </div>

              {/* Prix/m² */}
              <div className="table-cell">
                {(lot.price_total / lot.surface)?.toFixed(1) || 0 + " €"}
              </div>

              {/* Loyer */}
              <div className="table-cell">{lot.rent + " €"}</div>

              {/* Honoraires */}
              {/*  <div className="table-cell">
                {isDisplayed
                  ? lot.commission
                    ? lot.commission.match(/\d+\.\d+/) + "%"
                    : "NC"
                  : "***"}
              </div>
 */}
              {/* Action */}
              <div className="table-cell">
                <img
                  src={
                    isLotInFavorites(lot.documentId)
                      ? "./icons/favorite-filled.svg"
                      : "./icons/favorite-outline.svg"
                  }
                  alt="favorite"
                  height={35}
                  width={35}
                  className="cursor-pointer p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToFavorites(lot.documentId, "Lot");
                  }}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">Pas de lots favoris</div>
        )}
      </div>
    </div>
  );
};

export default ListeLotsEnregistres;
